import { inputs } from '@ecosystem/newron-design-system';
import { PagesConfig, usePageConfig } from '@utils/pageConfig/PagesConfigContext';
import { FilterKeys, Filters, Option, PageType } from '@utils/pageConfig/Types';
import { useEffect, useState } from 'react';

interface PriceInputProps {
  updateFilterCallback: (pagesConfig: PagesConfig, pageType: PageType, toUpdate: Filters) => void;
  getDisplayValueMinMax: (
    currentFilterMinValue: Filters,
    currentFilterMaxValue: Filters,
  ) => { selectedMinValue: string; selectedMaxValue: string };
  currencySymbol: string;
  disabled: boolean;
}

const PriceInput: React.FC<PriceInputProps> = ({
  updateFilterCallback,
  getDisplayValueMinMax,
  currencySymbol,
  disabled,
}) => {
  const currentFilterMinValue = {
    dataType: 'Min',
    feature: 'Min',
    filterTitle: 'Min',
    filterKey: FilterKeys.AVERAGE_PRICE_MIN,
    options: [],
    disabled: false,
  };
  const currentFilterMaxValue = {
    dataType: 'Max',
    feature: 'Max',
    filterTitle: 'Max',
    filterKey: FilterKeys.AVERAGE_PRICE_MAX,
    options: [],
    disabled: false,
  };

  const pagesConfig = usePageConfig();

  const [minInputValue, setMinInputValue] = useState<number>();
  const [maxInputValue, setMaxInputValue] = useState<number>();

  const updateSelectedFilters = (priceValue: string, filterTitle: string, filterKey: FilterKeys) => {
    let options: Option[] = [{ label: priceValue, value: priceValue }];
    const toUpdate: Filters = {
      dataType: filterTitle,
      feature: filterTitle,
      filterTitle,
      filterKey,
      options,
      disabled,
    };
    updateFilterCallback(pagesConfig, PageType.RI_PRODUCT, toUpdate);
  };

  const handleOnChange = (updateValue: number | null, isMax: boolean, isMin: boolean) => {
    if (updateValue !== undefined && updateValue !== null) {
      if (isMin) {
        updateSelectedFilters(updateValue.toString(), 'Min', FilterKeys.AVERAGE_PRICE_MIN);
      }
      if (isMax) {
        updateSelectedFilters(updateValue.toString(), 'Max', FilterKeys.AVERAGE_PRICE_MAX);
      }
    }
  };

  useEffect(() => {
    if (minInputValue !== undefined) {
      handleOnChange(minInputValue, false, true);
    }
  }, [minInputValue]);

  useEffect(() => {
    if (maxInputValue !== undefined) {
      handleOnChange(maxInputValue, true, false);
    }
  }, [maxInputValue]);

  const { NumberInput } = inputs;
  return (
    <div>
      <NumberInput
        label="Min"
        defaultValue={0}
        onChange={(value) => setMinInputValue(value ?? 0)}
        testId={'min-filter-input'}
        value={Number(getDisplayValueMinMax(currentFilterMinValue, currentFilterMaxValue).selectedMinValue)}
        disabled={disabled}
      >
        <NumberInput.Prefix>{currencySymbol}</NumberInput.Prefix>
      </NumberInput>
      <br />
      <NumberInput
        label="Max"
        defaultValue={0}
        onChange={(value) => setMaxInputValue(value ?? 0)}
        testId={'max-filter-input'}
        value={Number(getDisplayValueMinMax(currentFilterMinValue, currentFilterMaxValue).selectedMaxValue)}
        disabled={disabled}
      >
        <NumberInput.Prefix>{currencySymbol}</NumberInput.Prefix>
      </NumberInput>
    </div>
  );
};

export default PriceInput;
